import { render, staticRenderFns } from "./coup.vue?vue&type=template&id=74fed5c2&"
import script from "./coup.vue?vue&type=script&lang=js&"
export * from "./coup.vue?vue&type=script&lang=js&"
import style0 from "./coup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports